@let testResult = this.testResult();
<div class="mb-2">
  <div class="d-flex">
    <button class="btn btn-outline-success" [disabled]="disabled()" (click)="testConnection()">{{ 'TEST_CONNECTION' | translation }}</button>
    @if (!allowTest()) {
    <span class="mx-1" popover="{{ 'TEST_CONNECTION_DISABLED' | translation }}" [delay]="250" triggers="mouseenter:mouseleave">
      <i class="fa-regular fa-circle-question"></i>
    </span>
    }
  </div>
  @if (testResult) {
  <div class="mt-2">
    <h3>
      @if (testResult.success) {
      <span class="badge bg-success">{{ 'SUCCESS' | translation }}</span>
      } @else {
      <span class="badge bg-danger">{{ 'FAIL' | translation }}</span>
      }
    </h3>
    @if (!testResult.success) {
    <pre>{{ testResult?.message }}</pre>
    }
  </div>
  }
</div>
